module.exports = __webpack_public_path__ + "img/head-side-brain.6e422eea.svg";